<template>
    <editor api-key="gh7826upfjy7avgv166q91o8iks5dgygcf9dhvbb5d2d2ks0"
            :init="config"
            :value="value"
            @input="updateValue"
            @onClick="handleOnClick"
            @onKeyPress="handleKeyPress"
    > </editor>
</template>

<script>
    require('services/document-templates/tinymce/TinyMceConfig')
    import Editor from '@tinymce/tinymce-vue';
    import Form from 'services/form/Form';
    import VariableList from './VariableList'
    import {Config} from 'services/document-templates/tinymce/config/Config'
    import EditorUtils from 'services/document-templates/tinymce/EditorUtils'

    export default {
        name: "template-section",

        components: {
            Editor,
            VariableList
        },

        props: ['value', 'type'],

        data() {
            return {
                config: Config.make(this.type).get()
            }
        },

        methods: {
            updateValue(value) {
                this.$emit('input', value)
            },

            handleOnClick(e) {
                let node = EditorUtils.getCurrentPositionNode()
                if (EditorUtils.nodeIsVariable(node)) {
                    // EditorUtils.forceMoveCaretOutsideNode(node)
                }
            },

            handleKeyPress(e) {
                console.log(e.target.nodeName)
            }
        },

        mounted() {
            this.config.templates = _.map(Sincron.templateSections, (section) => {
                return {
                    title: section.name,
                    content: section.body
                }
            })
        }

    }
</script>